import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings, Settings } from '../../app.settings';
import {User, UserProfile, UserWork, UserContacts, UserSocial, UserSettings, Store} from './user.model';
import { UsersService } from './users.service';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../shared/models/apiurl.models";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UsersComponent implements OnInit {
    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.apiUrl.getJWTToken()
        })
    }
    public stores: Store[];
    public searchText: string;
    public page:any;
    public settings: Settings;
    constructor(public appSettings:AppSettings, 
                public dialog: MatDialog,
                public http: HttpClient, public apiUrl: ApiUrl,
                public usersService:UsersService){
        this.settings = this.appSettings.settings;
        this.usersService.getClickEvent().subscribe(res=>{
            if(res == "loadStores"){
                this.getStores();
            }
        })
    }

    ngOnInit() {
        this.getStores();
    }

    public getStores(): void {
        this.stores = null; //for show spinner each time
        this.usersService.getStores().subscribe(store => {
            this.stores = store.results.map((res) => {
                return {
                    id: res.id,
                    username: res.user.username,
                    password: res.passwordDisplay ,
                    profile: {
                        firstName: res.user?.firstName,
                        lastName: res.user?.lastName,
                        birthday: res.user?.birthday,
                        gender: res.user?.gender,
                        // image: res.user?.image
                    },
                    work: {
                        name: res?.name,
                        branch:
                            {
                                address1: res.branchList[0]?.address,
                                openingHours1: res.branchList[0]?.openingHours,
                                address2: res.branchList[1]?.address,
                                openingHours2: res.branchList[1]?.openingHours,
                            }
                    },
                    contacts: {
                        email: res.user.email,
                        mainPhone: res.user.mainPhone,
                        address: res.user.address
                    },
                    settings: {
                        isActive: res.user.active,
                        isDeleted: res.user.blocked || false,
                        registrationDate: res.user.dateJoined,
                        joinedDate: res.user.dateJoined
                    }


                }
            })
            console.log(this.stores)
        });
    }
    public addStore(store:Store){
        this.usersService.addStore(store).subscribe(user => this.getStores());
    }
    public updateUser(user:User){
        this.usersService.updateUser(user).subscribe(user => this.getStores());
    }
    public deleteUser(user:User){
       this.usersService.deleteUser(user.id).subscribe(user => this.getStores());
    }


    public onPageChanged(event){
        this.page = event;
        this.getStores();
        window.scrollTo(0,0);
    }

    public openUserDialog(user){
        console.log(user)
        let dialogRef = this.dialog.open(UserDialogComponent, {
            data: user
        });

        dialogRef.afterClosed().subscribe(user => {
            if(user){
                (user.id) ? this.updateUser(user) : this.addStore(user);
            }
        });
    }

    onBlock(store) {
        const deleted = store.settings.isDeleted
        const payLoad = {
            user:{
                blocked: !deleted,
                active:deleted
            }
        }
        this.usersService.partialUpdateUser(store, payLoad).subscribe(res =>{
            store.settings.isDeleted = !store.settings.isDeleted
        })

    }
}
